module.exports = __webpack_public_path__ + "media/react/organisms/navbars/nav_bar/assets/Magoosh-logo-purple-400x90-7526705ac1f6241ac6bb6686826618e4.png";